import {MatPaginatorIntl} from '@angular/material/paginator';
import {Injectable} from '@angular/core';

@Injectable()
export class MatPaginatorIntlDe extends MatPaginatorIntl {
  itemsPerPageLabel = 'Einträge pro Seite';
  nextPageLabel = 'nächste Seite';
  previousPageLabel = 'vorherige Seite';

  getRangeLabel = (page: number, pageSize: number, total: number) => {
    const n = page * pageSize + 1;
    const m = Math.min((page + 1) * pageSize + 1, total);
    return `${n} - ${m} von ${total}`;
  };
}
